export const LABEL_TYPE_OF_PRODUCT = "Type of Product";

export const SAF_DEFAULT_COUNTRY = "Sweden";

export default LABEL_TYPE_OF_PRODUCT;
